import searchApi from '@lib/api-fetch/search-api';

export async function getBusinessHandle(id: string, providerId = 'yelp') {
  console.log('[getBusinessHandle] START - id:', id, 'providerId:', providerId);
  const response = await searchApi('GET', `/v1/businesses/${providerId}/${id}`)
    .then((res) => {
      console.log('[getBusinessHandle] SUCCESS - response.ok:', res.ok, 'status:', res.status);
      console.log('[getBusinessHandle] SUCCESS - body:', JSON.stringify(res.body, null, 2));
      return res.body;
    })
    .catch((err) => {
      console.error('[getBusinessHandle] ERROR:', err);
      console.error('[getBusinessHandle] ERROR details:', JSON.stringify(err, null, 2));
      return err;
    });
  console.log('[getBusinessHandle] END - response:', JSON.stringify(response, null, 2));
  return response;
}
